import { DesktopNavigation } from "./desktop-navigation";
import { MobileNavigation } from "./mobile-navigation";
import { useMediaQuery, useTheme } from "@mui/material";
import React from "react";
export const Navigation = ({ desktopLogo, desktopStickyLogo, menuItems, mobileLogo, }) => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    return matches ? (React.createElement(DesktopNavigation, { logo: desktopLogo, stickyLogo: desktopStickyLogo, menuItems: menuItems })) : (React.createElement(MobileNavigation, { logo: mobileLogo, menuItems: menuItems }));
};
//# sourceMappingURL=navigation.js.map